// @ts-nocheck
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';

import PreviewTableChart from '../../ModelInventoryAndAssociation/PreviewTableChart';
import useModalDisclosure from '../../../../hooks/useModalDisclosure';

const ViewChart = ({ value, attribute }) => {
  const {
    open: openPreview,
    handleOpen: openModal,
    handleClose: closeModal,
  } = useModalDisclosure();

  const [previewItem, setPreviewItem] = useState({});

  const handleClosePreview = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const handleOpenPreview = useCallback(() => {
    openModal();
    setPreviewItem({
      item: value,
      type: 'image',
      title: attribute?.label || 'Default Chart',
    });
  }, [openModal, setPreviewItem, value]);

  return (
    <Grid container size={12}>
      <Grid size={12}>
        <Typography
          variant="body2"
          component="span"
          onClick={handleOpenPreview}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          View {attribute?.label || 'Chart'}
        </Typography>
      </Grid>
      <PreviewTableChart
        open={openPreview}
        handleClose={handleClosePreview}
        previewItem={previewItem}
      />
    </Grid>
  );
};

ViewChart.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  attribute: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
  iframeChartInFullView: PropTypes.bool.isRequired,
};

export default ViewChart;
